import { ApiEndpoints } from 'cng-common/configs/apiEndpoints'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { Rest } from 'core/classes/http'
import { IReference } from 'core/classes/models/IReference'
import VersionStoreService from 'core/classes/services/VersionStoreService'
import settings from 'src/config/settings'

import { getTranslationStorageKey } from '../helpers/getTranslationStorageKey'

export const setTranslations = async (key: string, value: string, locale: IReference) => {
  const view = settings.translateView || '1352'
  const payload = `{"${key}":"${value}"}` as any
  await VersionStoreService.updateApiVersion(getTranslationStorageKey(locale))
  return Rest.put({
    url: proxy(`${ApiEndpoints.translations.translationBase}/${view}/${locale && locale.value}`),
    payload,
  })
}
